import { _, _styled } from "i18n";
import "./errorPage.css";
import img from "assets/images/errors/403.png";
import { Link } from "react-router";

export default function ForbiddenPage() {
    return (
        <div className="errorPage-container errorPage-container-403">
            <div className="content">
                <img src={img} className="notFoundImg" />
                <div className="error-title">{_("label.accessDenied.title")}</div>
                <div className="error-text">
                    {_styled("label.accessDenied.text.formatted", {
                        b: (chunks: string) => <strong key={chunks}>{chunks}</strong>,
                    })}
                </div>
                <Link className="backToHomeButton" to="/">
                    {_("label.button.backToHome")}
                </Link>
            </div>
        </div>
    );
}
